import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserAddLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 14C18.7614 14 21 16.2386 21 19V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19C19 17.3431 17.6569 16 16 16H8C6.34315 16 5 17.3431 5 19V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19C3 16.2386 5.23858 14 8 14H16ZM20 8C20.5523 8 21 8.44772 21 9V10H22C22.5523 10 23 10.4477 23 11C23 11.5523 22.5523 12 22 12H21V13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13V12H18C17.4477 12 17 11.5523 17 11C17 10.4477 17.4477 10 18 10H19V9C19 8.44772 19.4477 8 20 8ZM12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2ZM12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4Z"
	})
});
export default SvgUserAddLine;
